<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  window.addEventListener("load", function () {
    document.querySelectorAll(".header__search")
        .forEach(element => {
            element.style.display = "flex";
        });
});
